var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar-items',[_c('v-btn',{attrs:{"flat":"flat","to":"/login"}},[_vm._v("\n            "+_vm._s(this.$store.getters["translate/translater"]
              .__("Login", "users"))+"\n          ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }